// removed by extract-text-webpack-plugin
module.exports = {"struggles-step":"struggles-step","subtitle":"subtitle","options":"options","option":"option","selected":"selected","btn-primary":"btn-primary"};


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/conversion-quiz/steps/struggles/struggles.style.sass
// module id = c00M
// module chunks = 1